/* @flow */
/* eslint-disable react/require-extension */
// Bootstrap environment

const onWindowIntl = () => {
  require("babel-polyfill");
  window.Promise = require("../common/configureBluebird");

  // App locales are defined in src/server/config.js
  const { addLocaleData } = require("react-intl");
  const pl = require("react-intl/locale-data/pl");
  const en = require("react-intl/locale-data/en");

  [pl, en].forEach(locale => addLocaleData(locale));

  require("./main");
};

// github.com/andyearnshaw/Intl.js/#intljs-and-browserifywebpack
if (!window.Intl) {
  require.ensure(
    ["intl", "intl/locale-data/jsonp/pl.js", "intl/locale-data/jsonp/en.js"],
    require => {
      require("intl");
      require("intl/locale-data/jsonp/pl.js");
      require("intl/locale-data/jsonp/en.js");

      onWindowIntl();
    }
  );
} else {
  onWindowIntl();
}

// My polyfills
Array.prototype.unique = function() {
  var a = this.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice((j--), 1);
    }
  }

  return a;
};



/** WEBPACK FOOTER **
 ** ./src/browser/index.js
 **/